const initialState = {
    websocketUrl: ''
  };
  
  const websocketReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_BASE_URL_WEBSOCKET':
            return { ...state, websocketUrl: action.payload };
        default:
            return state;
    }
  };
  
  export default websocketReducer;
  